<script>
import SalesAccountAttachments from '@/views/Application/Sales/Accounts/Account/Attachments'

export default {
  extends: SalesAccountAttachments,
  data () {
    return {
      breadcrumb: {
        name: 'Attachments',
        route: { name: 'sales-opportunities-account-attachments', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
